import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "disabled"],
  _excluded2 = ["children", "disabled", "textAlign"];
import styled from 'styled-components';
import { Button } from './Button';
import { LayoutTile } from '../Layout/LayoutTile';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledContent = styled(LayoutTile).withConfig({
  displayName: "ButtonTile__StyledContent",
  componentId: "sc-1ml07sm-0"
})(["--background:var(--layout-lib-background-color-light);background-color:var(--background);", " ", " line-height:1;&:hover{--background:", ";}a:has(&):hover{text-decoration:none;}a:has(&):focus-visible{outline:1px dotted ButtonText;outline:auto 1px -webkit-focus-ring-color;}", ""], ({
  $disabled
}) => $disabled ? `border: var(--layout-lib-border-light);` : `border: var(--layout-lib-border);`, ({
  theme
}) => `
    font-weight: ${theme.typography['heading-200'].fontWeight};
  `, ({
  theme
}) => theme.color['fill-field-hover'], ({
  $disabled
}) => $disabled && `
    color: var(--layout-lib-text-color-disabled);
    cursor: not-allowed;

    &:hover {
      --background: none;
    }
  `);
const Content = _ref => {
  let {
      children,
      disabled
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(StyledContent, Object.assign({}, rest, {
    $disabled: disabled,
    display: "block",
    flex: "1",
    forwardedAs: "span",
    inlineSize: "100%",
    children: children
  }));
};
export const ButtonTile = _ref2 => {
  let {
      children,
      disabled,
      textAlign
    } = _ref2,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  return /*#__PURE__*/_jsx(Button, Object.assign({}, rest, {
    block: true,
    disabled: disabled,
    variant: "unstyled",
    children: /*#__PURE__*/_jsx(Content, {
      disabled: disabled,
      textAlign: textAlign,
      children: children
    })
  }));
};